import React, { useState, useEffect, memo } from "react";
import ShowReels from "../components/showReels/ShowReels";
import HomeSecondSection from "../components/HomeSecondSection/homeSecondSection";
import ContactForm from "../components/ContactUsForm/ContactUsForm";
import { HomeProvider } from "../utils/homeContext/HomeContext";
import CaptureMoment from "../components/CaptureMoment/CaptureMoment";
import HeroHomeSec from "../components/HeroHomeSec/HeroHomeSec";
import InstagramFeed from "../components/InstagramFeed/InstagramFeed";
import AccordionFAQ from "../components/AccordionFAQ/AccordionFAQ";
import GoogleReviews from "../components/GoogleReviews/GoogleReviews";
import { Helmet } from "react-helmet";

const Home = () => {
  const [contentVisible, setContentVisible] = useState(false);
  const [heroLoaded, setHeroLoaded] = useState(false);

  useEffect(() => {
    // Simulating Hero Section Load Completion
    const heroLoadTimer = setTimeout(() => setHeroLoaded(true), 800); // Adjust timing if needed
    return () => clearTimeout(heroLoadTimer);
  }, []);

  useEffect(() => {
    if (heroLoaded) {
      const contentTimer = setTimeout(() => setContentVisible(true), 1000); // Delay after Hero
      return () => clearTimeout(contentTimer);
    }
  }, [heroLoaded]);

  return (
    <HomeProvider>
      <>
        <Helmet>
          <title> </title>
          <meta
            name="description"
            content="Studio Maamangala is a creative photography and cinematography studio based in Baripada, Odisha, specializing in weddings, pre-wedding shoots, and cinematic storytelling."
          />
          <meta
            name="keywords"
            content="Baripada wedding photography, Odisha cinematography, pre-wedding shoot Baripada, Studio Maamangala, Indian wedding videographer"
          />

          {/* Open Graph Tags */}
          <meta property="og:title" content="Studio Maamangala | Wedding & Event Visual Studio" />
          <meta property="og:description" content="Creative storytelling through wedding photography, cinematic videos, and pre-wedding shoots. Based in Baripada, Odisha." />
          <meta property="og:image" content="https://studiomaamangala.com/wp-content/uploads/2025/02/og-cover.jpg" />
          <meta property="og:url" content="https://studiomaamangala.com/" />
          <meta property="og:type" content="website" />

          {/* Twitter Card */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Studio Maamangala | Photography Studio in Baripada" />
          <meta name="twitter:description" content="Wedding photography and cinematic videography from Baripada, Odisha." />
          <meta name="twitter:image" content="https://studiomaamangala.com/wp-content/uploads/2025/02/og-cover.jpg" />

          {/* Structured Data for SEO */}
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "PhotographyStudio",
              "name": "Studio Maamangala",
              "image": "https://studiomaamangala.com/wp-content/uploads/2025/02/mmstudio.svg",
              "url": "https://studiomaamangala.com",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Baripada",
                "addressRegion": "Odisha",
                "addressCountry": "India"
              },
              "description": "Professional photography and cinematography studio for weddings, pre-weddings, and events.",
              "sameAs": [
                "https://www.facebook.com/hemantasahu9583/",
                "https://www.instagram.com/maa_mangala_studio/",
                "https://wa.me/8328803919"
              ]
            })}
          </script>
        </Helmet>

        <div style={{ position: "relative", zIndex: 1 }}>
          {/* ✅ Hero Section Renders First */}
          <HeroHomeSec />

          {/* ✅ Show Other Content ONLY After Hero is Loaded */}
          {heroLoaded && (
            <>
              <ShowReels />
              <div className={`contentWrapper ${contentVisible ? "visible" : ""}`}>
                <HomeSecondSection />
                <CaptureMoment />
                <InstagramFeed />
                <AccordionFAQ />
                <GoogleReviews />
                <ContactForm />
              </div>
            </>
          )}
        </div>
      </>
    </HomeProvider>
  );
};

export default memo(Home);
